<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>义诊活动记录</span>
      <span>
        <el-button plain style="width: 92px" size="medium" @click="back"
          >返回</el-button
        >
      </span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="flex" style="text-align: left; margin-bottom: 20px">
          <div>
            <span class="title">义诊开始时间</span>
            <span>{{ detail.start_time }}</span>
          </div>
          <div style="margin: 0 50px">
            <span class="title">义诊名额</span>
            <span>{{ detail.number }}</span>
          </div>
          <div>
            <span class="title">名额作废时间</span>
            <span>{{ detail.end_time }}</span>
          </div>
          <div style="margin: 0 50px">
            <span class="title">已参与医生数</span>
            <span>{{ detail.doctor_num }}</span>
          </div>
          <div>
            <span class="title">义诊数量</span>
            <span>{{ detail.people_num }}</span>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            ></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>

            <el-table-column prop="num" label="义诊数量"></el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      detail: {},
      tableData: []
    };
  },
  methods: {
    back() {
      history.back();
    },
    //获取详情
    getDetail() {
      let data = {
        free_id: this.$route.query.free_id,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/Activity/getFreeConsultActivityLogInfo', data)
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            this.detail.start_time = dayjs
              .unix(this.detail.start_time)
              .format('YYYY-MM-DD HH:mm');
            this.detail.end_time = dayjs
              .unix(this.detail.end_time)
              .format('YYYY-MM-DD HH:mm');
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getDetail();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getDetail();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  .title {
    font-weight: 700;
    margin-right: 10px;
  }
}
</style>
